
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Ustvari delovno tablo',
	'dashboard': 'Delovna tabla',
	'dashboardTemplate': 'Predloga delovne table',
	'createAV': 'Ustvari',
	'createAvEditNameLabel': '1. Poimenujte pogled',
	'createAvSelectTemplateLabel': '2. Izberi predlogo',
	'tabLayoutLabel': 'Predloga z zavihki',
	'infographicsLayoutLabel': 'Vizualna predloga',
	'singlePageLayoutLabel': 'Predloga z eno stranjo',
	'customLayoutLabel': 'Predloga po meri',
	'freeformTemplate': 'Prostoročna oblika',
	'freeformTemplateDesc': 'Vizualizacije v postavitvi prostoročne oblike se pojavijo točno tako, kot jih postavite znotraj pogleda, ne glede na velikost zaslona. Pri drugih postavitvah se velikost in položaj vizualizacij prilagajata, da se prilegata velikosti zaslona.',
	'NoTemplate': 'Prostoročna oblika',
	'Template1': 'Prazno',
	'Template2': 'Naslov 1 po 2',
	'Template3': '2 prek 1',
	'Template4': '4 prek 1',
	'Template5': 'Noga 1 po 2',
	'Template6': '3 poleg 1 prek 1',
	'Template7': '4 poleg 3 prek 1',
	'Template8': '2 prek 3 po 2',
	'Template9': '2 po 2',
	'Template10': '1 po 2 poleg 2 po 2 prek 1',
	'Template11': '3 po 1 prek 1 po 2',
	'Template12': '2 prek 1 poleg 1 po 2',
	'Template13': 'Ena poleg 1 po 2 poleg 1 po 4',
	'Template14': 'Prazno s spustnim območjem',
	'Infographics1': 'Prazno',
	'Infographics2': '4 vrstice',
	'Infographics3': '4 vrstice z glavami',
	'Infographics4': '2 po 4',
	'Infographics5': 'Povečan zgornji prikaz z 2 po 2',
	'Infographics6': '2 po 4 z navpično vrzeljo',
	'Infographics7': '2 po 4, razporejeno',
	'Infographics8': 'Teniško igrišče',
	'Infographics9': '3 po 4',
	'Infographics10': '4 po 8',
	'createAvDashboardLabel': 'Postavitev',
	'dashboard_template_save_success': 'Predloga delovne table je bila shranjena.',
	'dashboard_template_prefix': 'Predloga: \'%{name}\'',
	'dashboard_template_filters_removed': 'Filtri na platnu so bili odstranjeni.',
	'createAvTabLabel': 'Z zavihki',
	'createAvInfographicsLabel': 'Vizualna predstavitev',
	'createAvSinglepageLabel': 'Ena sama stran',
	'createAvCustomLabel': 'Po meri',
	'loadMoreLabel': 'Naloži več ...',
	'backLabel': 'Pojdi nazaj',
	'addSourceLabel': 'Dodaj izvor',
	'pinLabel': 'Pripni',
	'errorLoadingDataSetMetaData': 'Med branjem metapodatkov je prišlo do napake',
	'errorLoadingDataSets': 'Med nalaganjem seznama naborov podatkov je prišlo do napake',
	'errorLoadingDataSet': 'Metapodatki za nabor podatkov \'%{datasetName}\' se niso naložili. Prosimo, da se za podrobnosti obrnete na skrbnika.',
	'okButton': 'V redu',
	'createButton': 'Ustvari',
	'cancelButton': 'Prekliči',
	'copyButton': 'Prekopiraj',
	'selectTemplateLabel': 'Izberi predlogo',
	'noSourcesSelectedLabel': 'Noben izvor ni izbran',
	'find_label': 'Najdi',
	'noDashboardFound': 'Delovne table ni mogoče pridobiti. Ne obstaja več ali pa nimate zadostnih privilegijev za ogled.',
	'errorLabel': 'Napaka',
	'defaultName': 'Nova delovna tabla',
	'noDashboardCapability': 'Nimate zmožnosti za izvajanje aplikacije za delovne table',
	'noCapabilityForEdit': 'Nimate zmožnosti za urejanje te delovne table',
	'noCapabilityForSave': 'Nimate zmožnosti, da bi shranili to delovno tablo',
	'noCapabilityForPaste': 'V ta pogled ne morete lepiti kopiranih gradnikov',
	'noCapabilityForPin': 'Nimate zmožnosti za dodajanje te priponke',
	'noDashboardPermission': 'Nimate zadostnih privilegijev za ogled te delovne table',
	'sourceNotFound': 'Vizualizacije ni mogoče naložiti, ker z njo povezan izvor \'%{sourceName}\' ni na voljo',
	'cmDuplicateName': 'Postavka s tem imenom že obstaja. Poskusite z drugim imenom.',
	'cmEmptySelection': 'Delovna tabla je bila izbrisana. Poskusite shraniti kot novo delovno tablo.',
	'propTheme': 'Vizualna tema',
	'defaultThemeLabel': 'Privzeto',
	'lightThemeLabel': 'Svetlo',
	'darkThemeLabel': 'Temno',
	'titleTextLabel': 'Naslov',
	'titleSmallTextLabel': 'Majhen naslov',
	'subtitleTextLabel': 'Podnaslov',
	'bodyTextLabel': 'Telo',
	'bodySmallTextLabel': 'Majhno telo',
	'captionTextLabel': 'Napis',
	'quoteTextLabel': 'Citat',
	'quoteSmallTextLabel': 'Majhen citat',
	'responsiveTextLabel': 'Samodejna nastavitev velikosti',
	'mediaWidgetLabel': 'Medij',
	'webpageWidgetLabel': 'Spletna stran',
	'imageWidgetLabel': 'Slika',
	'textWidgetLabel': 'Besedilo',
	'notebookWidgetLabel': 'Beležnica',
	'multipurposeWidgetLabel': 'Večnamenski',
	'textPlaceHolder': 'Sem vnesite besedilo',
	'titlePlaceHolder': 'Sem vnesite naslov',
	'toggleEditModeLabel': 'Preklopi na urejanje',
	'togglePreviewModeLabel': 'Preklopi na predogled',
	'editDashboardCoachMarkTitle': 'Urejanje delovne table',
	'editDashboardCoachMarkContents': 'Kliknite ikono svinčnika, če želite urediti to delovno tablo.',
	'addDataCoachMarkTitle': 'Dodaj podatke',
	'addDataDashboardCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v vašo delovno tablo.',
	'pageSelectWarning': 'Izberite zavihek.',
	'screenshot_label': 'Delovna tabla %{title}',
	'screenshot_label_tab': 'Zavihek %{tabName} delovne table %{title}',
	'dataAssetPropertiesLabel': 'Lastnosti vizualizacije',
	'modelFilter': 'Filtriraj',
	'invertSelectionToolTip': 'Obrni izbore filtrov',
	'clearFilterValueToolTip': 'Počisti vrednosti filtrov',
	'invertFilterSelection': 'Obrni',
	'clearTextFilterValue': 'Počisti',
	'filterConditionLabel': 'Pogoj filtra',
	'applyFilter': 'Uveljavi filter',
	'itemCountText': 'Št. izbranih postavk: %{itemCount}',
	'itemExcludeCountText': 'Št. izvzetih postavk: %{itemCount}',
	'moreMembers': 'Pokaži več ...',
	'searchHierarchyMembers': 'Poišči člane z iskanjem ...',
	'propHideEmpty': 'Skrij prazno',
	'propColorOrder': 'Vrstni red barv',
	'propElementColor': 'Barva vizualizacijskega elementa',
	'propLineColor': 'Barva črte',
	'propLineAndSymbolColor': 'Barva črt in simbolov',
	'propColumnColor': 'Barva stolpca',
	'propBarColor': 'Barva palic',
	'propWordColor': 'Barva besed',
	'propAreaColor': 'Barva področja',
	'propRadialbarColor': 'Barva radialnega paličnega grafikona',
	'propColorPalettes': 'Barvne palete',
	'propDashboardColorPalette': 'Trenutna paleta delovne table',
	'propNewDashboardPaletteLabel': 'Ustvari paleto delovne table po meri',
	'propDashboardChangePaletteLink': 'Spremeni paleto delovne table',
	'propHideLeafNode': 'Skrij vodilne oznake',
	'propOpacity': 'Neprosojnost',
	'propOpacityDescription': 'Objekt naredite bolj ali manj neprosojen. Vnesite vrednost med 0 in 100.',
	'addATab': 'Dodaj nov zavihek',
	'propFredIsRed': 'Skladnost barv',
	'areaChartCaption': 'Področni',
	'areaChartDataSlot_categoriesLabel': 'Oznaka osi',
	'areaChartDataSlot_valuesLabel': 'Vrednost',
	'areaChartProp_colorPaletteLabel': 'Barvne palete',
	'areaChartProp_lineColorLabel': 'Barva področja',
	'areaChartProp_interpolationLabel': 'Gladke črte',
	'areaChartProp_interpolationDescription': 'Črte, ki povezujejo podatkovne točke, so ukrivljene.',
	'areaChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'areaChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'areaChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'areaChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'areaChartProp_suppressZerosLabel': 'Skrij prazno',
	'areaChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'barChartCaption': 'Palični grafikon',
	'barChartDataSlot_categoriesLabel': 'Oznaka osi',
	'barChartDataSlot_valuesLabel': 'Vrednost',
	'barChartProp_colorPaletteLabel': 'Barvne palete',
	'barChartProp_elementColorLabel': 'Barva palic',
	'barChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'barChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'barChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'barChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'barChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'barChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'barChartProp_suppressZerosLabel': 'Skrij prazno',
	'barChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'columnChartCaption': 'Stolpčni',
	'columnChartDataSlot_categoriesLabel': 'Oznaka osi',
	'columnChartDataSlot_valuesLabel': 'Vrednost',
	'columnChartProp_colorPaletteLabel': 'Barvne palete',
	'columnChartProp_elementColorLabel': 'Barva stolpca',
	'columnChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'columnChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'columnChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'columnChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'columnChartProp_suppressZerosLabel': 'Skrij prazno',
	'columnChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'bubbleChartCaption': 'Mehurčni',
	'bubbleChartDataSlot_xAxisLabel': 'Vodoravna os',
	'bubbleChartDataSlot_yAxisLabel': 'Navpična os',
	'bubbleChartDataSlot_sizeLabel': 'Velikost po',
	'bubbleChartDataSlot_colorLabel': 'Pobarvaj po',
	'bubbleChartProp_colorPaletteLabel': 'Barvne palete',
	'bubbleChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'bubbleChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'bubbleChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'bubbleChartProp_hideLegendLabel': 'Skrij legendo',
	'bubbleChartProp_hideLegendDescription': 'Skrij legendo.',
	'bubbleChartProp_legendPositionLabel': 'Položaj legende',
	'lineChartCaption': 'Črtni grafikon',
	'lineChartDataSlot_categoriesLabel': 'Oznaka osi',
	'lineChartDataSlot_valuesLabel': 'Vrednost',
	'lineChartProp_colorPaletteLabel': 'Barvne palete',
	'lineChartProp_lineColorLabel': 'Barva črt in simbolov',
	'lineChartProp_symbolShapeLabel': 'Oblika simbola',
	'lineChartProp_hideSymbolsLabel': 'Skrij simbole',
	'lineChartProp_hideSymbolsDescription': 'Skrij simbole',
	'lineChartProp_hideDataLinesLabel': 'Skrij črte',
	'lineChartProp_hideDataLinesDescription': 'Skrij črte',
	'lineChartProp_interpolationLabel': 'Gladke črte',
	'lineChartProp_interpolationDescription': 'Črte, ki povezujejo podatkovne točke, so ukrivljene.',
	'lineChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'lineChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'lineChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'lineChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'lineChartProp_suppressZerosLabel': 'Skrij prazno',
	'lineChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'packedBubbleChart1CatCaption': 'Strnjeni mehurčni grafikon',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorije',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Velikost po',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Barvne palete',
	'packedBubbleChart1CatProp_elementColorLabel': 'Barva mehurčka',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Skrij oznako',
	'packedBubbleChart1CatProp_hideValueLabel': 'Skrij vrednost',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Skrij prazno',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'heatChartCaption': 'Toplotni grafikon',
	'heatChartDataSlot_valuesLabel': 'Toplotni po',
	'heatChartDataSlot_xAxisLabel': 'Vodoravna os',
	'heatChartDataSlot_yAxisLabel': 'Navpična os',
	'heatChartProp_colorPaletteLabel': 'Barvne palete',
	'heatChartProp_heatScalePaletteLabel': 'Vrstni red barv',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'heatChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'heatChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'heatChartProp_suppressZerosLabel': 'Skrij prazno',
	'heatChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'heatChartProp_hideLegendLabel': 'Skrij legendo',
	'heatChartProp_hideLegendDescription': 'Skrij legendo.',
	'heatChartProp_legendPositionLabel': 'Položaj legende',
	'pieChartCaption': 'Tortni grafikon',
	'pieChartDataSlot_categoriesLabel': 'Kategorije',
	'pieChartDataSlot_valuesLabel': 'Vrednost',
	'pieChartProp_colorPaletteLabel': 'Barvne palete',
	'pieChartProp_hideRadialValueLabel': 'Skrij vrednost',
	'pieChartProp_pieAsDonutLabel': 'Prikaži kot kolobarni grafikon',
	'pieChartProp_pieAsDonutDescription': 'Prikaži kot kolobarni grafikon',
	'pieChartProp_suppressZerosLabel': 'Skrij prazno',
	'pieChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'pieChartProp_hideLegendLabel': 'Skrij legendo',
	'pieChartProp_hideLegendDescription': 'Skrij legendo.',
	'pieChartProp_legendPositionLabel': 'Položaj legende',
	'map1measureCaption': 'Zemljevid',
	'map1measureDataSlot_categoriesLabel': 'Regije',
	'map1measureDataSlot_valuesLabel': 'Toplotni regijski grafikon',
	'map1measureProp_colorPaletteLabel': 'Barvne palete',
	'map1measureProp_heatScalePaletteLabel': 'Vrstni red barv',
	'map1measureProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'map1measureProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'map1measureProp_suppressZerosLabel': 'Skrij prazno',
	'map1measureProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'map1measureProp_hideLegendLabel': 'Skrij legendo',
	'map1measureProp_hideLegendDescription': 'Skrij legendo.',
	'map1measureProp_legendPositionLabel': 'Položaj legende',
	'radialChartCaption': 'Radialni grafikon',
	'radialChartDataSlot_categoriesLabel': 'Kategorije',
	'radialChartDataSlot_valuesLabel': 'Vrednost',
	'radialChartProp_colorPaletteLabel': 'Barvne palete',
	'radialChartProp_elementColorLabel': 'Barva radialnega paličnega grafikona',
	'radialChartProp_hideRadialTitleLabel': 'Skrij naslov',
	'radialChartProp_hideRadialValueLabel': 'Skrij vrednost',
	'radialChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'radialChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'radialChartProp_suppressZerosLabel': 'Skrij prazno',
	'radialChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'pointChart1catCaption': 'Točkovni grafikon',
	'pointChart1catDataSlot_valuesLabel': 'Vrednost',
	'pointChart1catDataSlot_categoriesLabel': 'Oznaka osi',
	'pointChart1catProp_colorPaletteLabel': 'Barvne palete',
	'pointChart1catProp_elementColorLabel': 'Barva oblike',
	'pointChart1catProp_symbolShapeLabel': 'Oblika simbola',
	'pointChart1catProp_symbolFillLabel': 'Oblika polnila',
	'pointChart1catProp_symbolFillDescription': 'Prikaži barvo polnila za simbole.',
	'pointChart1catProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'pointChart1catProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'pointChart1catProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'pointChart1catProp_suppressZerosLabel': 'Skrij prazno',
	'pointChart1catProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'scatterPlotChartNoCatCaption': 'Raztreseni grafikon',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vodoravna os',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Navpična os',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Barvne palete',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Barva elementa',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Oblika simbola',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Oblika polnila',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Prikaži barvo polnila za simbole.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'radialBarChartCaption': 'Radialni palični grafikon',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorije',
	'radialBarChartDataSlot_valuesLabel': 'Vrednost',
	'radialBarChartProp_colorPaletteLabel': 'Barvne palete',
	'radialBarChartProp_elementColorLabel': 'Barva radialnega paličnega grafikona',
	'radialBarChartProp_hideRadialTitleLabel': 'Skrij naslov',
	'radialBarChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'radialBarChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'radialBarChartProp_suppressZerosLabel': 'Skrij prazno',
	'radialBarChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'lineColumnComboChartCaption': 'Črtni in stolpčni grafikon',
	'lineColumnComboChartDataSlot_categoryLabel': 'Oznaka osi',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Vrednost črte',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Vrednost stolpca',
	'lineColumnComboChartProp_colorPaletteLabel': 'Barvne palete',
	'lineColumnComboChartProp_elementColorLabel': 'Barva stolpca',
	'lineColumnComboChartProp_lineColorLabel': 'Barva črt in simbolov',
	'lineColumnComboChartProp_symbolShapeLabel': 'Oblika simbola',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Skrij simbole',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Skrij simbole',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Skrij črte',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Skrij črte',
	'lineColumnComboChartProp_interpolationLabel': 'Gladke črte',
	'lineColumnComboChartProp_interpolationDescription': 'Črte, ki povezujejo podatkovne točke, so ukrivljene.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Skrij mrežne črte',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Skrij mrežne črte',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Skrij oznake naslovov osi',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Skrij naslove za osi.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Skrij prazno',
	'lineColumnComboChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'lineColumnComboChartProp_hideLegendLabel': 'Skrij legendo',
	'lineColumnComboChartProp_hideLegendDescription': 'Skrij legendo.',
	'lineColumnComboChartProp_legendPositionLabel': 'Položaj legende',
	'summaryCaption': 'Seštevek',
	'areaName': 'Področni grafikon',
	'areaDescription': 'Področni grafikon',
	'areaDataSlot_colorLabel': 'Pobarvaj po',
	'areaDataSlot_valuesLabel': 'Vrednost',
	'areaDataSlot_categoriesLabel': 'Oznaka osi',
	'bubbleName': 'Mehurčni grafikon',
	'bubbleDescription': 'Mehurčni grafikon',
	'bubbleDataSlot_yAxisLabel': 'Navpična os',
	'bubbleDataSlot_xAxisLabel': 'Vodoravna os',
	'bubbleDataSlot_sizeLabel': 'Velikost po',
	'bubbleDataSlot_colorLabel': 'Pobarvaj po',
	'clusterBarName': 'Palični grafikon',
	'clusterBarDescription': 'Palični grafikon',
	'clusterBarDataSlot_colorLabel': 'Pobarvaj po',
	'clusterBarDataSlot_valuesLabel': 'Vrednost',
	'clusterBarDataSlot_categoriesLabel': 'Oznaka osi',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Vrednost',
	'clusterColumnName': 'Stolpčni grafikon',
	'clusterColumnDescription': 'Stolpčni grafikon',
	'clusterColumnDataSlot_colorLabel': 'Pobarvaj po',
	'clusterColumnDataSlot_valuesLabel': 'Vrednost',
	'clusterColumnDataSlot_categoriesLabel': 'Oznaka osi',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Vrednost',
	'clusterLineName': 'Črtni grafikon',
	'clusterLineDescription': 'Črtni grafikon',
	'clusterLineDataSlot_colorLabel': 'Pobarvaj po',
	'clusterLineDataSlot_valuesLabel': 'Navpična os',
	'clusterLineDataSlot_categoriesLabel': 'Vodoravna os',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Vrednost',
	'gridName': 'Mreža',
	'gridDescription': 'Mreža',
	'gridDataSlot_grid_colsLabel': 'Stolpčni grafikon',
	'heatName': 'Toplotni grafikon',
	'heatDescription': 'Toplotni grafikon',
	'heatDataSlot_yAxisLabel': 'Navpična os',
	'heatDataSlot_xAxisLabel': 'Vodoravna os',
	'heatDataSlot_valuesLabel': 'Toplotni po',
	'lineColumnComboName': 'Črtni in stolpčni grafikon',
	'lineColumnComboDescription': 'Črtni in stolpčni grafikon',
	'lineColumnComboDataSlot_lineValueLabel': 'Vrednost črte',
	'lineColumnComboDataSlot_categoryLabel': 'Oznaka osi',
	'lineColumnComboDataSlot_columnValueLabel': 'Vrednost stolpca',
	'mapName': 'Zemljevid starejše različice',
	'mapDescription': 'Zemljevid starejše različice',
	'mapDataSlot_sizeLabel': 'Velikost točk',
	'mapDataSlot_valuesLabel': 'Toplotni regijski grafikon',
	'mapDataSlot_sizeHeatLabel': 'Toplotni točkovni grafikon',
	'mapDataSlot_categoriesLabel': 'Regije',
	'packedBubbleName': 'Strnjeni mehurčni grafikon',
	'packedBubbleDescription': 'Strnjeni mehurčni grafikon',
	'packedBubbleDataSlot_sizeLabel': 'Velikost po',
	'packedBubbleDataSlot_colorLabel': 'Pobarvaj po',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorije',
	'pieName': 'Tortni grafikon',
	'pieDescription': 'Tortni grafikon',
	'pieDataSlot_valuesLabel': 'Vrednost',
	'pieDataSlot_categoriesLabel': 'Kategorije',
	'playerName': 'Predvajalnik podatkov',
	'playerDescription': 'Predvajalnik podatkov',
	'playerDataSlot_categoriesLabel': 'Oznaka osi',
	'pointName': 'Točkovni grafikon',
	'pointDescription': 'Točkovni grafikon',
	'pointDataSlot_colorLabel': 'Pobarvaj po',
	'pointDataSlot_valuesLabel': 'Vrednost',
	'pointDataSlot_categoriesLabel': 'Oznaka osi',
	'radialName': 'Radialni grafikon',
	'radialDescription': 'Radialni grafikon',
	'radialDataSlot_valuesLabel': 'Vrednost',
	'radialDataSlot_maxSizeLabel': 'Največja vrednost',
	'radialDataSlot_categoriesLabel': 'Kategorije',
	'radialBarName': 'Radialni palični grafikon',
	'radialBarDescription': 'Radialni palični grafikon',
	'radialBarDataSlot_valuesLabel': 'Vrednost',
	'radialBarDataSlot_categoriesLabel': 'Kategorije',
	'scatterPlotName': 'Raztreseni grafikon',
	'scatterPlotDescription': 'Raztreseni grafikon',
	'scatterPlotDataSlot_yAxisLabel': 'Navpična os',
	'scatterPlotDataSlot_xAxisLabel': 'Vodoravna os',
	'scatterPlotDataSlot_colorLabel': 'Pobarvaj po',
	'scatterPlotDataSlot_categoriesLabel': 'Točke',
	'stackedBarName': 'Strukturni palični grafikon',
	'stackedBarDescription': 'Strukturni palični grafikon',
	'stackedBarDataSlot_colorLabel': 'Pobarvaj po',
	'stackedBarDataSlot_valuesLabel': 'Vrednost',
	'stackedBarDataSlot_categoriesLabel': 'Oznaka osi',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Vrednost',
	'stackedColumnName': 'Strukturni stolpčni grafikon',
	'stackedColumnDescription': 'Strukturni stolpčni grafikon',
	'stackedColumnDataSlot_colorLabel': 'Pobarvaj po',
	'stackedColumnDataSlot_valuesLabel': 'Vrednost',
	'stackedColumnDataSlot_categoriesLabel': 'Oznaka osi',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Vrednost',
	'summaryChartName': 'Seštevek',
	'summaryChartDescription': 'Seštevek',
	'summaryChartDataSlot_valuesLabel': 'Vrednost',
	'treeMapName': 'Mozaični graf',
	'treeMapDescription': 'Mozaični grafikon',
	'treeMapDataSlot_colorLabel': 'Toplotni po',
	'treeMapDataSlot_valuesLabel': 'Velikost po',
	'treeMapDataSlot_categoriesLabel': 'Prva raven',
	'treeMapDataSlot_level3Label': 'Tretja raven',
	'treeMapDataSlot_level2Label': 'Druga raven',
	'wordCloudName': 'Besedni oblak',
	'wordCloudDescription': 'Besedni oblak',
	'wordCloudDataSlot_colorLabel': 'Pobarvaj po',
	'wordCloudDataSlot_scaleLabel': 'Velikost po',
	'wordCloudDataSlot_wordLabel': 'Besede',
	'treeMap1Cat1MeasureChartCaption': 'Mozaični grafikon',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Prva raven',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Velikost po',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Barvne palete',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Skrij prazno',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Skrij legendo',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Skrij legendo.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Položaj legende',
	'wordChart1Cat1MeasureCaption': 'Besedni oblak',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Besede',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Velikost po',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Barvne palete',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Barva besed',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Ohrani merilo osi',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Vedno prikaži najmanjše in največje vrednosti na oseh.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Skrij prazno',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Skrij kategorije brez povezanih vrednosti.',
	'missingDataSetData': 'Podatki za ta nabor podatkov niso na voljo. Osvežite nabor podatkov ali pa se za dostop do izvora obrnite na skrbnika.',
	'hideShowSummaries': 'Pokaži/skrij povzetke',
	'crosstabName': 'Navzkrižna tabela',
	'value_is_not_available': 'Ni na voljo',
	'swapRowsAndColumns': 'Zamenjaj vrstice in stolpce',
	'NoPinsCollected': 'Ni pripetih vizualizacij',
	'pinSearchOld': 'Išči po mojih priponkah',
	'pinDeletedToast': 'Priponka je bila odstranjena',
	'pinAddedToast': 'Priponka je bila uspešno dodana med Moje priponke',
	'pinRetrieveError': 'Ene ali več priponk ni mogoče pridobiti. Poskusite znova pozneje.',
	'pinErrorTitle': 'Napaka pripenjanja',
	'pinRemove': 'Odstrani priponko',
	'deletePin': 'Izbriši priponko',
	'dataset_time': 'čas',
	'dataset_date': 'datum',
	'dataset_location': 'lokacija',
	'dataset_number': 'število',
	'dataset_text': 'besedilo',
	'widgetConditionalFormatLabel': 'Preklopi kontrolnike pogojnega oblikovanja',
	'deletePinConfirmationMessage': 'Ali ste prepričani, da želite izbrisati to priponko? Tega dejanja ni mogoče razveljaviti.',
	'deletePinConfirm': 'Potrdi brisanje',
	'pinDeleteError': 'Ene ali več priponk ni mogoče izbrisati. Poskusite znova pozneje.',
	'conditionalPalettePickerLabel': 'Distribucija vrednosti %{title}',
	'HistogramYAxisTitle': 'Število',
	'metadataPickerTitle': 'Ustvari nabor podatkov',
	'moreTitle': 'Več',
	'remove_slider_handle': 'Odstrani ročko',
	'missingFiltering': 'Manjkajoči stolpec:',
	'unSupportedPromptType': 'Scenarij s pozivi trenutno ni podprt.',
	'preAggregateLabel': 'Uveljavi vrednosti poziva iz izvora podatkov',
	'postAggregateLabel': 'Uveljavi vrednosti poziva v poročilu',
	'preAggregateText': 'Obseg uporablja vrednosti v izvoru podatkov, ne vrednosti, ki so prikazane na delovni tabli.',
	'tabName_general': 'Splošno',
	'tabName_visDetails': 'Podrobnosti',
	'tabName_textDetails': 'Podrobnosti besedila',
	'tabName_mediaDetails': 'Podrobnosti medija',
	'tabName_webDetails': 'Podrobnosti spletne strani',
	'tabName_imageDetails': 'Podrobnosti slike',
	'tabName_visualization': 'Vizualizacija',
	'sectionName_canvas': 'Platno',
	'sectionName_colorsAndThemes': 'Barva in tema',
	'sectionName_appearance': 'Videz',
	'sectionName_advanced': 'Napredno',
	'sectionName_layout': 'Postavitev',
	'sectionName_tabs': 'Zavihki',
	'sectionName_tabTitle': 'Oznaka',
	'sectionName_tabBackground': 'Ozadje',
	'addDataSourceDialogTitle': 'Dodaj izvor podatkov',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'shapesDoubleChevron': 'Dvojne škarnice',
	'widgetsPanelTitle': 'Gradniki',
	'widgetsPanelImageLibraryTab': 'Knjižnica slik',
	'widgetsPanelSectionBasic': 'Osnovno',
	'widgetsPanelSectionAdvanced': 'Napredno',
	'widgetsPanelSectionShapes': 'Oblike',
	'customWidgetsTitle': 'Gradniki po meri',
	'filterItemCanvasMove': 'Dodaj na platno',
	'filterOverflowMenu_Global': 'Prelivni meni - vsi zavihki',
	'filterOverflowMenu_Tab': 'Prelivni meni - ta zavihek',
	'filterOverflowMenu_Item': 'Prelivni meni - filtriranje',
	'filterOverflowMenu_Single': 'Prelivni meni',
	'filterItemEdit': 'Urejanje vrednosti filtrov',
	'filterDeleteAllItems': 'Izbriši vse filtre',
	'filterClearAllItems': 'Počisti vse filtre',
	'filterClearSelection': 'Počisti filter',
	'filterPlayerMode': 'Pokaži predvajalnik',
	'filterStaticMode': 'Pokaži seznam',
	'filterInvertSelection': 'Obrni filter',
	'filterIconLabel_Global': 'Vsi zavihki',
	'filterIconLabel_Single': 'Filtri',
	'filterIconLabel_Tab': 'Ta zavihek',
	'filterIconTooltip_Global': 'Vsi zavihki',
	'filterIconTooltip_Tab': 'Ta zavihek',
	'filterIconTooltip_Single': 'Filtri',
	'filterItemDelete': 'Izbriši filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'vse razen: %{from}-%{to}',
	'filterExcept': 'razen %{values}',
	'filterAll': 'Vse',
	'filterBlank': '(prazno)',
	'filterDisableRangeInvert': 'Ni na voljo, če je ta stolpec v filtru \'Vsi zavihki\'.',
	'filterDisableHierarchyInvert': 'Ni na voljo, če je ta stolpec v filtru hierarhije.',
	'filterSelectedOfTotal': '%{selected} od %{totalMembers}',
	'filter_date_before': 'Pred %{to}',
	'filter_date_before_except': 'Ne pred %{to}',
	'filter_date_after': 'Po %{from}',
	'filter_date_after_except': 'Ne po %{from}',
	'filter_date_between': 'Med %{from}-%{to}',
	'filter_date_between_except': 'Ne med %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Povlecite in spustite podatke sem, da filtrirate vse zavihke.',
	'filter_drag_and_drop_current_tab': 'Povlecite in spustite podatke sem, da filtrirate ta zavihek.',
	'filter_drag_and_drop_single_dock': 'Povlecite in spustite podatke sem, da filtrirate.',
	'errMsgFilterItemGenericTitle': 'Vrednosti filtrov ni mogoče naložiti',
	'widgetChromeRotate': 'Zavrti',
	'toolbarRegionLabel': 'Orodna vrstica',
	'toolbarActionDelete': 'Izbriši',
	'toolbarActionGroup': 'Skupina',
	'toolbarActionUngroup': 'Razgrupiraj',
	'toolbarActionOrderToFront': 'Pošlji v ospredje',
	'toolbarActionOrderToBack': 'Pošlji v ozadje',
	'toolbarActionEditTitle': 'Urejanje naslova',
	'toolbarActionWrapTitle': 'Oblij naslov',
	'toolbarActionPin': 'Zberi',
	'toolbarActionPinOld': 'Pripni',
	'toolbarActionAlign': 'Poravnaj',
	'alignWidgetLeft': 'Levo',
	'alignWidgetCenter': 'Sredina',
	'alignWidgetRight': 'Desno',
	'alignWidgetTop': 'Zgoraj',
	'alignWidgetMiddle': 'Sredina',
	'alignWidgetBottom': 'Spodaj',
	'toolbarChangeVisualization': 'Spremeni vizualizacijo',
	'live_label': 'Grafikon',
	'filter_label': 'Filter',
	'one_named_live': 'Grafikon %{name}',
	'one_named_live_numbered': 'Grafikon (%{number}) %{name}',
	'one_unknown_live': 'Grafikon',
	'one_unknown_live_numbered': 'Grafikon (%{number})',
	'few_live': 'Skupina %{count} grafikonov',
	'many_live': 'Skupina %{count} grafikonov',
	'one_custom': 'Gradnik po meri',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filter %{name}',
	'one_named_filter_numbered': 'Filter (%{number}) %{name}',
	'one_unknown_filter': 'Filter',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Skupina %{count} filtrov',
	'many_filter': 'Skupina %{count} filtrov',
	'LIVE_bar_has_mapping': 'Palični grafikon %{values}',
	'LIVE_bar_has_mapping_numbered': 'Palični grafikon (%{number}) %{values}',
	'LIVE_bar_opt_mapping': 'Palični grafikon %{categories} po %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Palični grafikon (%{number}) %{categories} po %{values}',
	'LIVE_bar_no_mapping': 'Prazen palični grafikon',
	'LIVE_bar_no_mapping_numbered': 'Prazen palični grafikon (%{number})',
	'LIVE_bar_named': 'Palični grafikon %{name}',
	'LIVE_bar_named_numbered': 'Palični grafikon (%{number}) %{name}',
	'LIVE_stacked_bar_has_mapping': 'Strukturirani palični grafikon %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Strukturni palični grafikon (%{number}) %{values}',
	'LIVE_stacked_bar_opt_mapping': 'Strukturni palični grafikon %{categories} po %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Strukturni palični grafikon (%{number}) %{categories} po %{values}',
	'LIVE_stacked_bar_no_mapping': 'Prazen strukturni palični grafikon',
	'LIVE_stacked_bar_no_mapping_numbered': 'Prazen strukturni palični grafikon (%{number})',
	'LIVE_stacked_bar_named': 'Strukturni palični grafikon %{name}',
	'LIVE_stacked_bar_named_numbered': 'Strukturni palični grafikon (%{number}) %{name}',
	'LIVE_bubble_has_mapping': 'Mehurčni grafikon %{categories} po %{x} in %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Mehurčni grafikon (%{number}) %{categories} po %{x} in %{y}',
	'LIVE_bubble_no_mapping': 'Prazen mehurčni grafikon',
	'LIVE_bubble_no_mapping_numbered': 'Prazen mehurčni grafikon (%{number})',
	'LIVE_bubble_named': 'Mehurčni grafikon %{name}',
	'LIVE_bubble_named_numbered': 'Mehurčni grafikon (%{number}) %{name}',
	'LIVE_composite_has_mapping': 'Sestavljeni grafikon %{categories} po %{columnValue} in %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Sestavljeni grafikon (%{number}) %{categories} po %{columnValue} in %{lineValue}',
	'LIVE_composite_no_mapping': 'Prazen sestavljeni grafikon',
	'LIVE_composite_no_mapping_numbered': 'Prazen sestavljeni grafikon (%{number})',
	'LIVE_composite_named': 'Sestavljeni grafikon %{name}',
	'LIVE_composite_named_numbered': 'Sestavljeni grafikon (%{number}) %{name}',
	'LIVE_decision_tree_has_mapping': 'Odločitveno drevo %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Odločitveno drevo (%{number}) %{values}',
	'LIVE_decision_tree_no_mapping': 'Prazno odločitveno drevo',
	'LIVE_decision_tree_no_mapping_numbered': 'Prazno odločitveno drevo (%{number})',
	'LIVE_decision_tree_named': 'Odločitveno drevo %{name}',
	'LIVE_decision_tree_named_numbered': 'Odločitveno drevo (%{number}) %{name}',
	'LIVE_packed_bubble_has_mapping': 'Strnjeni mehurčni grafikon %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Strnjeni mehurčni grafikon (%{number}) %{categories}',
	'LIVE_packed_bubble_no_mapping': 'Prazen strnjeni mehurčni grafikon',
	'LIVE_packed_bubble_no_mapping_numbered': 'Prazen strnjeni mehurčni grafikon (%{number})',
	'LIVE_packed_bubble_named': 'Strnjeni mehurčni grafikon %{name}',
	'LIVE_packed_bubble_named_numbered': 'Strnjeni mehurčni grafikon (%{number}) %{name}',
	'LIVE_pie_has_mapping': 'Tortni grafikon %{categories} po %{values}',
	'LIVE_pie_has_mapping_numbered': 'Tortni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_pie_no_mapping': 'Prazen tortni grafikon',
	'LIVE_pie_no_mapping_numbered': 'Prazen tortni grafikon (%{number})',
	'LIVE_pie_named': 'Tortni grafikon %{name}',
	'LIVE_pie_named_numbered': 'Tortni grafikon (%{number}) %{name}',
	'LIVE_pie_as_donut_has_mapping': 'Kolobarni grafikon %{categories} po %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Kolobarni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_pie_as_donut_no_mapping': 'Prazen kolobarni grafikon',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Prazen kolobarni grafikon (%{number})',
	'LIVE_pie_as_donut_named': 'Kolobarni grafikon %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Kolobarni grafikon (%{number}) %{name}',
	'LIVE_line_has_mapping': 'Črtni grafikon %{categories} po %{values}',
	'LIVE_line_has_mapping_numbered': 'Črtni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_line_no_mapping': 'Prazen črtni grafikon',
	'LIVE_line_no_mapping_numbered': 'Prazen črtni grafikon (%{number})',
	'LIVE_line_named': 'Črtni grafikon %{name}',
	'LIVE_line_named_numbered': 'Črtni grafikon (%{number}) %{name}',
	'LIVE_area_has_mapping': 'Področni grafikon %{categories} po %{values}',
	'LIVE_area_has_mapping_numbered': 'Področni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_area_no_mapping': 'Prazen področni grafikon',
	'LIVE_area_no_mapping_numbered': 'Prazen področni grafikon (%{number})',
	'LIVE_area_named': 'Področni grafikon %{name}',
	'LIVE_area_named_numbered': 'Področni grafikon (%{number}) %{name}',
	'LIVE_area_as_stacked_percent_has_mapping': 'Strukturni odstotni področni grafikon %{categories} po %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Strukturni odstotni področni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_area_as_stacked_percent_no_mapping': 'Prazen skladovni odstotni področni grafikon',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Prazen strukturni odstotni področni grafikon (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Strukturni odstotni področni grafikon %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Strukturni odstotni področni grafikon (%{number}) %{name}',
	'LIVE_heatmap_has_mapping': 'Toplotni grafikon %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Toplotni grafikon (%{number}) %{color}',
	'LIVE_heatmap_no_mapping': 'Prazen toplotni grafikon',
	'LIVE_heatmap_no_mapping_numbered': 'Prazen toplotni grafikon (%{number})',
	'LIVE_heatmap_named': 'Toplotni grafikon %{name}',
	'LIVE_heatmap_named_numbered': 'Toplotni grafikon (%{number}) %{name}',
	'LIVE_network_opt_mapping': 'Omrežje %{categories} po %{series} in %{values}',
	'LIVE_network_opt_mapping_numbered': 'Omrežje (%{number}) %{categories} po %{series} in %{values}',
	'LIVE_network_has_mapping': 'Omrežje %{categories} po %{series}',
	'LIVE_network_has_mapping_numbered': 'Omrežje %{categories} po %{series} (%{number})',
	'LIVE_network_no_mapping': 'Prazno omrežje',
	'LIVE_network_no_mapping_numbered': 'Prazno omrežje (%{number})',
	'LIVE_network_named': 'Omrežje %{name}',
	'LIVE_network_named_numbered': 'Omrežje (%{number}) %{name}',
	'LIVE_radial_bar_opt_mapping': 'Radialni palični grafikon %{categories} po %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Radialni palični grafikon (%{number}) %{categories} po %{values}',
	'LIVE_radial_bar_has_mapping': 'Radialni palični grafikon %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Radialni palični grafikon (%{number}) %{values}',
	'LIVE_radial_bar_no_mapping': 'Prazen radialni palični grafikon',
	'LIVE_radial_bar_no_mapping_numbered': 'Prazen radialni palični grafikon (%{number})',
	'LIVE_radial_bar_named': 'Radialni palični grafikon %{name}',
	'LIVE_radial_bar_named_numbered': 'Radialni palični grafikon (%{number}) %{name}',
	'LIVE_spiral_has_mapping': 'Spiralni grafikon %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Spiralni grafikon (%{number}) %{values}',
	'LIVE_spiral_no_mapping': 'Prazen spiralni grafikon',
	'LIVE_spiral_no_mapping_numbered': 'Prazen spiralni grafikon (%{number})',
	'LIVE_spiral_named': 'Spiralni grafikon %{name}',
	'LIVE_spiral_named_numbered': 'Spiralni grafikon (%{number}) %{name}',
	'LIVE_treemap_has_mapping': 'Mozaični grafikon %{categories} po %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Mozaični grafikon (%{number}) %{categories} po %{size}',
	'LIVE_treemap_no_mapping': 'Prazen mozaični grafikon',
	'LIVE_treemap_no_mapping_numbered': 'Prazen mozaični grafikon (%{number})',
	'LIVE_treemap_named': 'Mozaični grafikon %{name}',
	'LIVE_treemap_named_numbered': 'Mozaični grafikon (%{number}) %{name}',
	'LIVE_wordcloud_has_mapping': 'Besedni oblak %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Besedni oblak (%{number}) %{categories}',
	'LIVE_wordcloud_no_mapping': 'Prazen besedni oblak',
	'LIVE_wordcloud_no_mapping_numbered': 'Prazen besedni oblak (%{number})',
	'LIVE_wordcloud_named': 'Besedni oblak %{name}',
	'LIVE_wordcloud_named_numbered': 'Besedni oblak (%{number}) %{name}',
	'LIVE_data_player_has_mapping': 'Predvajalnik podatkov %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Predvajalnik podatkov (%{number}) %{category}',
	'LIVE_data_player_no_mapping': 'Prazen predvajalnik podatkov',
	'LIVE_data_player_no_mapping_numbered': 'Prazen predvajalnik podatkov (%{number})',
	'LIVE_data_player_named': 'Predvajalnik podatkov %{name}',
	'LIVE_data_player_named_numbered': 'Predvajalnik podatkov (%{number}) %{name}',
	'LIVE_map_has_mapping': 'Zemljevid %{locations}',
	'LIVE_map_has_mapping_numbered': 'Zemljevid (%{number}) %{locations}',
	'LIVE_map_no_mapping': 'Prazna preslikava',
	'LIVE_map_no_mapping_numbered': 'Prazen zemljevid (%{number})',
	'LIVE_map_named': 'Zemljevid %{name}',
	'LIVE_map_named_numbered': 'Zemljevid (%{number}) %{name}',
	'LIVE_point_has_mapping': 'Točkovni grafikon %{categories} po %{values}',
	'LIVE_point_has_mapping_numbered': 'Točkovni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_point_no_mapping': 'Prazen točkovni grafikon',
	'LIVE_point_no_mapping_numbered': 'Prazen točkovni grafikon (%{number})',
	'LIVE_point_named': 'Točkovni grafikon %{name}',
	'LIVE_point_named_numbered': 'Točkovni grafikon (%{number}) %{name}',
	'LIVE_column_has_mapping': 'Stolpčni grafikon %{values}',
	'LIVE_column_has_mapping_numbered': 'Stolpčni grafikon (%{number}) %{values}',
	'LIVE_column_opt_mapping': 'Stolpčni grafikon %{categories} po %{values}',
	'LIVE_column_opt_mapping_numbered': 'Stolpčni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_column_no_mapping': 'Prazen stolpčni grafikon',
	'LIVE_column_no_mapping_numbered': 'Prazen stolpčni grafikon (%{number})',
	'LIVE_column_named': 'Stolpčni grafikon %{name}',
	'LIVE_column_named_numbered': 'Stolpčni grafikon (%{number}) %{name}',
	'LIVE_stacked_column_has_mapping': 'Strukturni stolpčni grafikon %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Strukturni stolpčni grafikon (%{number}) %{values}',
	'LIVE_stacked_column_opt_mapping': 'Strukturni stolpčni grafikon %{categories} po %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Strukturni stolpčni grafikon (%{number}) %{categories} po %{values}',
	'LIVE_stacked_column_no_mapping': 'Prazen strukturni stolpčni grafikon',
	'LIVE_stacked_column_no_mapping_numbered': 'Prazen strukturni stolpčni grafikon (%{number})',
	'LIVE_stacked_column_named': 'Strukturni stolpčni grafikon %{name}',
	'LIVE_stacked_column_named_numbered': 'Strukturni stolpčni grafikon (%{number}) %{name}',
	'LIVE_scatter_opt_mapping': 'Raztreseni grafikon %{categories} po %{x} in %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Raztreseni grafikon %{categories} po %{x} in %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Raztreseni grafikon %{x} v primerjavi s %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Raztreseni grafikon %{x} v primerjavi s %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Prazen raztreseni grafikon',
	'LIVE_scatter_no_mapping_numbered': 'Prazen raztreseni grafikon (%{number})',
	'LIVE_scatter_named': 'Raztreseni grafikon %{name}',
	'LIVE_scatter_named_numbered': 'Raztreseni grafikon %{name} (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} stopničasti grafikon',
	'LIVE_waterfall_has_mapping_numbered': '%{values} stopničasti grafikon (%{number})',
	'LIVE_waterfall_no_mapping': 'Prazen stopničasti grafikon',
	'LIVE_waterfall_no_mapping_numbered': 'Prazen stopničasti grafikon (%{number})',
	'LIVE_waterfall_named': 'Stopničasti grafikon %{name}',
	'LIVE_waterfall_named_numbered': 'Stopničasti grafikon %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Zgradite svojo vizualizacijo',
	'LIVE_empty_visualization_hint_description': 'Povlecite in spustite stolpce sem ali na reže na levi.',
	'LIVE_slots_required_field_description': '%{asterisk} Označuje obvezno polje',
	'LIVE_slots_drag_and_drop_description': 'Povlecite in spustite podatke na reže zgoraj, da zgradite in filtrirate vizualizacijo.',
	'requiredField': 'Obvezno polje',
	'fullScreenEnter': 'Vstop v celozaslonski način',
	'fullScreenClose': 'Izhod iz celozaslonskega načina',
	'noExtraText_multipurpose': 'Večnamensko rezervirano mesto',
	'noExtraText_multipurpose_numbered': 'Večnamensko rezervirano mesto (%{number})',
	'one_placeholder_vis': 'Rezervirano mesto vizualizacije',
	'one_placeholder_vis_numbered': 'Rezervirano mesto vizualizacije (%{number})',
	'one_placeholder_text': 'Rezervirano mesto za besedilo',
	'one_placeholder_text_numbered': 'Rezervirano mesto za besedilo (%{number})',
	'few_placeholder_text': 'Skupina %{count} rezerviranih mest za besedilo',
	'many_placeholder_text': 'Skupina %{count} rezerviranih mest za besedilo',
	'filter_includesAll': 'Vključuje vse',
	'timeline_filter_moved_to': 'Filter časovnice %{id}, premaknjen na %{time}',
	'timelineSettingsButton': 'Možnosti predvajanja',
	'autoPlay': 'Predvajaj vse scene',
	'loop': 'Zanka',
	'noSceneTransitionLabel': 'Brez',
	'sceneTransitionPropertyLabel': 'Prehod med scenami',
	'animatedPathSceneTransitionLabel': 'Animirana pot',
	'sweepSceneTransitionLabel': 'Pometi',
	'propAniAnimation': 'Animacija',
	'propAniTypeEntrance': 'Animacija ob vstopu',
	'propAniDirectionIn': 'Smer vstopa',
	'propAniTypeExit': 'Animacija ob izhodu',
	'propAniDirectionOut': 'Smer izhoda',
	'propAniDirection': 'Smer',
	'timelineAnimationProperties': 'Odpri lastnosti animacije',
	'editStoryCoachMarkTitle': 'Urejanje zgodbe',
	'editStoryCoachMarkContents': 'Kliknite ikono svinčnika, da uredite to zgodbo.',
	'addDataStoryCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v zgodbo.',
	'expandSceneCoachmarkTitle': 'Odpri časovnico',
	'expandSceneCoachmarkContents': 'Animacija prizora s prilagoditvijo vidljivosti objekta na podlagi časa in trajanja.',
	'overviewCoachmarkTitle': 'Scene pregleda',
	'overviewCoachmarkContents': 'S scenami pregleda na začetku in koncu zgodbe prikažete celotno sliko vseh scen. V sceni pregleda kliknite in povlecite sceno, da jo zamenjate z drugo sceno. Scene pregleda lahko pokažete ali skrijete v lastnostih zgodbe.',
	'animatedPathCoachmarkTitle': 'Animirana pot',
	'animatedPathCoachmarkContents': 'Če želite animirati objekt iz enega prizora v drugega, podvojite prizor z objektom. Nato premaknite, spremenite velikost ali zasukajte podvojeni objekt v novem prizoru.',
	'tabName_animation': 'Animacija',
	'textWidgetIconPlaceholderText': 'Kliknite, da dodate besedilo',
	'visIconPlaceholderText': 'Povlecite in spustite podatke, da zgradite vizualizacijo',
	'launchNewExplore': 'Novo raziskovanje',
	'addTo': 'Dodaj v',
	'addToExisting': 'Dodaj med obstoječe ...',
	'exploreData': 'Razišči',
	'explore_remove_widget_styles': 'Lastnosti vizualizacije po meri, na primer barvne nastavitve, se ne ohranijo v raziskovanju.',
	'editNotebook': 'Urejanje gradnika',
	'thumbnails_error_fetching': 'Napaka pri pridobivanju sličic',
	'copy': 'Št. prekopiranih sredstev: %{count}',
	'specConvertErr': 'Med lepljenjem ali pretvarjanjem specifikacije delovne table je prišlo do napake',
	'specCopyErr': 'Napaka pri kopiranju specifikacije delovne table',
	'pasteNotSupportedErr': 'Lepljenje iz %{name} ni podprto.',
	'reportParam': 'poročilo',
	'filterWidgetCopyWarn': 'Vizualizacija filtra ni bila kopirana, ker filtri trenutno niso podprti.',
	'upgradingDashboard': 'Nadgradnja \'%{name}\' za %{version} ...',
	'upgradeComplete': 'Nadgradnja je končana',
	'individualTabProperties': 'Lastnosti posameznega zavihka',
	'propMasterTabStylesLabel': 'Slog glavnega zavihka',
	'propTabPosition': 'Položaj zavihka',
	'propTabTitle': 'Naslov',
	'propTabBackgroundColor': 'Barva polnila',
	'propTabTextColor': 'Barva naslova',
	'propTabSelectedBarColor': 'Barva izbrane vrstice',
	'propTabRestoreDefaults': 'Obnovi privzeto',
	'propIndividualTabStylesLabel': 'Slog glavnega zavihka',
	'propIndividualTabStylesAriaLabel': 'Odpri lastnosti sloga posameznega zavihka',
	'propTabIconPosition': 'Položaj ikone',
	'propLeftTitle': 'Levo od naslova',
	'propRightTitle': 'Desno od naslova',
	'propTopTitle': 'Nad naslovom',
	'propBottomTitle': 'Pod naslovom',
	'propTabIconLabel': 'Pogled',
	'propTabIcon': 'Ikona',
	'propTabIconColor': 'Barva ikone',
	'no_icon': 'Prazno',
	'announcement': 'Objava',
	'api': 'Api',
	'archive': 'Arhiv',
	'asset': 'Sredstvo',
	'attachment': 'Priponka',
	'audio': 'Zvočni posnetek',
	'bee': 'Čebela',
	'blog': 'Blog',
	'bookmark': 'Zaznamek',
	'calendar': 'Koledar',
	'camera': 'Kamera',
	'capability': 'Zmožnost',
	'catalog': 'Katalog',
	'chat_message': 'Sporočilo v klepetu',
	'checkout_cart': 'Košarica',
	'client': 'Odjemalec',
	'clock': 'Ura',
	'cloud': 'Oblak',
	'code': 'Koda',
	'data_quality': 'Kakovost podatkov',
	'folder': 'Mape',
	'forum': 'Forum',
	'glasses': 'Očala',
	'group': 'Skupina',
	'hat': 'Klobuk',
	'headphone': 'Slušalke',
	'hills': 'Hribi',
	'home': 'Začetna stran',
	'idea': 'Ideja',
	'image': 'Slika',
	'inventory': 'Zaloga',
	'like': 'Kot',
	'link': 'Povezava',
	'location': 'Lokacija',
	'manage': 'Upravljanje',
	'pen': 'Pero',
	'mobile_phone': 'Mobilni telefon',
	'music': 'Glasba',
	'notifications': 'Obvestila',
	'paint': 'Slikar',
	'payment': 'Plačilo',
	'password_key': 'Ključ za geslo',
	'people': 'Osebe',
	'person': 'Oseba',
	'phone': 'Telefon',
	'pin': 'Pripni',
	'print': 'Natisni',
	'recording': 'Posnetek',
	'repository': 'Repozitorij',
	'role': 'Vloga',
	'search': 'Iskanje',
	'properties': 'Lastnosti',
	'speaker': 'Zvočnik',
	'star': 'Zvezdica',
	'tag': 'Oznaka',
	'thumbs_up': 'Gor obrnjen palec',
	'thumbs_down': 'Dol obrnjen palec',
	'tools': 'Orodja',
	'traffic': 'Promet',
	'trash': 'Smeti',
	'twitter': 'Twitter',
	'unknown': 'Neznano',
	'user': 'Uporabnik',
	'venn_diagram': 'Diagram Venn',
	'video': 'Videoposnetek',
	'view': 'Pogled',
	'warning': 'Opozorilo',
	'watch': 'Opazovanje',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Delovni prostor',
	'world': 'Svet',
	'OnLoadFilterModifierDatasourceMismatch': 'Filtri ne bodo uveljavljeni za cilj, ker nadzorne plošče uporabljajo različne vire.',
	'OnLoadFilterModifierColumnMismatch': 'En ali več filtrov ni bilo uveljavljenih, ker ujemajočih se stolpcev ni bilo mogoče najti.',
	'eventGroupButtonLabel': 'Ogled povezav gradnikov',
	'dockToolbar': 'Zasidraj orodno vrstico',
	'undockToolbar': 'Odsidraj orodno vrstico',
	'propShowTitle': 'Pokaži naslov'
});
